import {
  dropSsoWorkspaceNameFromLocalstorage,
  getWorkspaceNameFromLocalstorage,
  getWorkspaceNameFromUrl,
  persistSsoWorkspaceNameInLocalstorage,
} from '@neptune/sso-domain';

export function persistSsoWorkspaceName(workspace: string) {
  if (workspace) {
    persistSsoWorkspaceNameInLocalstorage(workspace);
  } else {
    dropSsoWorkspaceNameFromLocalstorage();
  }
}

export function loadSsoWorkspaceName(): string {
  return getWorkspaceNameFromUrl() || getWorkspaceNameFromLocalstorage();
}
